import React, { useMemo } from 'react';
import Chart from 'react-apexcharts';
import GraphLoader from './GraphLoader';

const smartFormat = (val) => {
    if (val === null || val === undefined) return '';
    return val < 10 ? val.toFixed(2) : Math.round(val);
};

const TelemetryGraphComponent = ({ categories, series }) => {
    const hasNoData = !series?.length || !categories?.length;
    const totalPoints = categories?.length || 0;

    const options = useMemo(
        () => ({
            chart: {
                type: 'line',
                height: 520,
                animations: { enabled: false },
                toolbar: { show: true },
                zoom: { enabled: true },
                redrawOnParentResize: false,
                redrawOnWindowResize: false,
            },
            markers: { size: totalPoints > 300 ? 0 : 4 },
            dataLabels: { enabled: false },
            stroke: { width: 2, curve: 'straight' },

            legend: { show: true, position: 'bottom' },

            xaxis: {
                type: 'datetime',
                categories,
                title: { text: 'Date / Time' },
                labels: {
                    datetimeUTC: false,
                    format: 'dd MMM HH:mm',
                    style: { fontSize: '10px' },
                },
            },

            yaxis: {
                title: { text: 'Value' },
                tickAmount: 8,
                forceNiceScale: true,

                axisBorder: {
                    show: true,
                },
                axisTicks: {
                    show: true,
                },
                labels: {
                    formatter: smartFormat,
                    style: { fontSize: '11px' },
                    offsetX: -5,
                },
            },

            tooltip: {
                shared: true,
                intersect: false,
                x: {
                    format: 'dd MMM yyyy HH:mm:ss',
                },
                y: {
                    formatter: smartFormat,
                },
            },
        }),
        [categories, totalPoints]
    );

    if (hasNoData) {
        return (
            <div
                style={{
                    height: 520,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#888',
                }}>
                <i className="fa fa-chart-line" style={{ fontSize: '32px', marginBottom: '10px' }}></i>
                <p style={{ margin: 0, fontWeight: 500 }}>No data available for this selection</p>
            </div>
        );
    }

    return <Chart options={options} series={series} type="line" height={520} className="apex-charts mt-3" />;
};

export default React.memo(TelemetryGraphComponent);
